import { createSlice } from "@reduxjs/toolkit"


const filesSlice = createSlice({
    name: "file",
    initialState: {

        file: null,
        files: null,
        filteredfiles: null,
        filter: {
            search: null,
            pagination: null,

        },
        filterfileCount: [
            10, 50, 100, 200, 300
        ],
        pagination: null,

        selectedpagination: 0

    },
    reducers: {

        setFile(state, action) {
            state.file = action.payload
        },
        setFiles(state, action) {
            state.files = action.payload
        }
        ,
        setFilteredItems(state, action) {
            state.filteredfiles = action.payload
        }
        ,
        resetFiles(state) {
            state.files = null
            state.filteredfiles = null
            state.filter = {
                search: null,
                pagination: null,
            }
        }
        ,
        setFilter(state, action) {

            if (Array.isArray(action.payload)) {
                action.payload.map(item => {
                    state.filter[item.key] = item.value
                })
            }
            else {
                state.filter[action.payload.key] = action.payload.value
            }


        },
        setPagination(state, action) {
            state.pagination = action.payload
        },

        setSelectedPagination(state, action) {
            state.selectedpagination = action.payload
        }

    },
});

export default filesSlice

export const fileActions = filesSlice.actions;